import * as React from "react";
// Components
import { MessageBar as FluentMessageBar, MessageBarType } from "@fluentui/react";
import { blockedIconProps, calendarDueDateLateProps, completedIconProps, dismissCircleIconProps, dismissIconProps, infoIconProps } from "../../../icons/icons.styles";
/**
 * MessageBar component from Fluent with our customizations
 */ export const MessageBar = (props)=>{
    let messageBarIconProps = infoIconProps;
    if (props.messageBarType != null) {
        switch(props.messageBarType){
            case MessageBarType.success:
                messageBarIconProps = completedIconProps;
                break;
            case MessageBarType.error:
                messageBarIconProps = dismissCircleIconProps;
                break;
            case MessageBarType.blocked:
                messageBarIconProps = blockedIconProps;
                break;
            case MessageBarType.severeWarning:
                messageBarIconProps = calendarDueDateLateProps;
                break;
            case MessageBarType.info:
            case MessageBarType.warning:
            default:
                messageBarIconProps = infoIconProps;
        }
    }
    return /*#__PURE__*/ React.createElement(FluentMessageBar, {
        dismissIconProps: dismissIconProps,
        messageBarIconProps: messageBarIconProps,
        ...props
    });
};
